import {Component, OnDestroy, OnInit} from '@angular/core';
import 'rxjs/add/observable/fromEvent';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-redirect-mobile',
  templateUrl: './redirect-mobile.component.html',
  styleUrls: ['./redirect-mobile.component.scss']
})
export class RedirectMobileComponent implements OnInit, OnDestroy {

  public lang = "";

  languageMap: { [key: string]: string } = {
    en: "English",
    pl: "Polski",
    de: "Deutsch",
    cs: "Čeština",
    fr: "Français",
    pt: "Português",
    it: "Italiano",
    ro: "Română",
    da: "Dansk",
    ar: "العربية",
    bg: "Български",
    no: "Norsk",
    nl: "Nederlands",
    sr: "Српски",
    et: "Eesti",
    lv: "Latviešu",
    sl: "Slovenščina",
    sk: "Slovenčina",
    es: "Español",
  };

  constructor(
    public translate: TranslateService,
  ) {

  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  public changeLanguage(lang: string): void {
    window.localStorage["lang"] = lang;
    this.lang = lang;
    this.translate.use(lang);
  }

}
